export default "<app-appointment-list></app-appointment-list>\r\n";